import { Navigate, Route, Routes } from "react-router-dom";
import LoginPage from "../pages/login/LoginPage";
import LandingPage from "../pages/landing/LandingPage";
import ClassesPage from "../pages/classes/ClassesPage";
import PeriodClosedPage from "../pages/closed/PeriodClosedPage";
import Layout from "../layout/Layout";
import { ProtectedRoute } from "../layout/ProtectedRoute";
import { RequireAccess } from "../layout/RequireAccess";

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/closed" element={<PeriodClosedPage />} />
            <Route
                element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }
            >
                <Route path="/" element={<LandingPage />} />
                <Route
                    path="/classes"
                    element={
                        <RequireAccess>
                            <ClassesPage />
                        </RequireAccess>
                    }
                />
                {/* /my-registrations đã merge vào /classes (3-section combined giống Old) */}
                <Route
                    path="/my-registrations"
                    element={<Navigate to="/classes" replace />}
                />
            </Route>
        </Routes>
    );
};

export default AppRoutes;
